import { Badge, BoxV2 as Box, Flex } from 'portal-commons';
import { FC } from 'react';
import { faCircleCheck } from '@fortawesome/pro-regular-svg-icons';

import { Section, SectionContent, SectionItem, SectionTitle } from './atoms';
import { CampaignDetail } from '@/apis/core';
import { CampaignStatus } from '@/constants/enum';
import { humanizeCampaignStatus } from '@/utils/string';

interface CarrierStatusSectionProps {
  campaign: CampaignDetail;
}

export const CarrierStatusSection: FC<CarrierStatusSectionProps> = ({
  campaign,
}) => {
  const rulesEngineResults = campaign.rulesEngineResultsJson
    ? JSON.parse(campaign.rulesEngineResultsJson)
    : {};
  const mno = rulesEngineResults.mno || '--';
  const qualify = rulesEngineResults.qualify || false;

  const qualifyType = qualify ? 'success' : 'error';
  const statusType =
    campaign.status === CampaignStatus.Active ? 'success' : 'error';

  return (
    <Section>
      <SectionTitle>Carrier Status</SectionTitle>
      <Flex
        sx={{
          flexDirection: 'column',
          gap: 'm',
          p: 'm',
          border: '1px solid #C0CCD4',
          borderRadius: '8px',
        }}
      >
        <Box
          sx={{
            color: '#000',
            fontWeight: 600,
            fontSize: 'H300',
            lineHeight: 'normal',
          }}
        >
          {mno}
        </Box>
        <SectionContent columns={2}>
          <SectionItem title="Qualify">
            <Badge
              size="lg"
              shape="rectangle"
              variant="fill"
              sx={{ width: 'fit-content' }}
              type={qualifyType}
              startAdornment={qualify ? faCircleCheck : undefined}
            >
              {qualify ? 'Yes' : 'No'}
            </Badge>
          </SectionItem>
          <SectionItem title="DCA Name">{campaign.dcaName}</SectionItem>
          <SectionItem title="TCR Status">
            <Badge
              size="lg"
              shape="rectangle"
              variant="fill"
              sx={{ width: 'fit-content' }}
              type={statusType}
              startAdornment={
                campaign.status === CampaignStatus.Active
                  ? faCircleCheck
                  : undefined
              }
            >
              {humanizeCampaignStatus(campaign.status)}
            </Badge>
          </SectionItem>
        </SectionContent>
      </Flex>
    </Section>
  );
};

export default CarrierStatusSection;
